module.exports = __webpack_public_path__ + "img/Autocolant VVH_55mm x 60mm-01.417abda5.jpg";